import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';
import { LogicEngine } from '../LogicEngine/LogicEngine';

export class StepSetValue extends StepBase
{
    /** Value from the query or other options */
    count : number = 0;

    /** Process the query associated with the stat */
    async processStep(logic : LogicEngine) : Promise<boolean>
    {
        await super.processStep(logic);
        await logic.processSetCommand(this.options.value, this.text, this.raw.field_id, this.raw.option_1);
        return true;
    }

    /**
     * The data for Dash Button is <text to show>;<table to count results from>
     */
    constructor(rawData: PageStepType)
    {
        super(rawData);
    }
}